<template>
  <div class="page">

    <div class="bar_nav">
      <div class="title">我</div>
    </div>
    <div class="bar_empty"></div>

      <div class="avatar_area">
        <div class="avatar_box">
          <div class="avatar_image" :style="{backgroundImage: 'url(' + userInfo.avatarCdnUrl + ')'}" v-if="userInfo.avatar"></div>
          <div class="avatar_image default" v-if="userInfo.avatar === ''"></div>
          <div class="circle_border" @click="updateAvatar"></div>
        </div>
      </div>

      <input type="file" style="display: none" ref="avatarInput" @change="onAvatarInputChange" />

      <!-- <div class="phone">{{userInfo.mobilePhone}}</div> -->

      <div class="table">
        <div class="table_section">
          <mt-cell title="手机号"  :value="userInfo.mobilePhone"></mt-cell>
          <mt-cell title="我的昵称" :to="`/user/${userInfo.id}/edit_full_name`" is-link value=""></mt-cell>
          <mt-cell title="修改密码" :to="`/user/${userInfo.id}/edit_password`" is-link value=""></mt-cell>
        </div>

        <div class="table_section">
          <!-- <mt-cell title="用户反馈" :to="`/user/${userInfo.id}/edit_password`" is-link value=""></mt-cell> -->
          <mt-cell title="关于我们" :to="`/user/${userInfo.id}/about_us`" is-link value=""></mt-cell>
          <!-- <mt-cell title="联系我们" :to="`/user/${userInfo.id}/edit_password`" is-link value=""></mt-cell> -->
        </div>

        <div class="table_section" @click="logout">
          <mt-cell title="退出登录" class="link_quit"></mt-cell>
        </div>
      </div>
  </div>
</template>

<script>
export default {
  name: 'UserSetting',
  data: function () {
    return {
      inviteCode: '',
      userInfo: {}
    }
  },
  async created() {
    try {
      this.userInfo = await this.$faApi.getUserInfo(this.$route.params.userId)
    } catch (err) {
      this.$faLogger.error('UserSetting.vue:created', err)
    }
  },
  methods: {
    async logout () {
      try {
        await this.$faApi.logout()
        this.$router.push({ path: '/' })
      } catch (err) {
        this.$faLogger.error('UserSetting.vue:logout', err)
      }
    },
    updateAvatar() {
      this.$refs.avatarInput.click()
    },
    async onAvatarInputChange(e) {
      const postData = new FormData()
      postData.append('file', e.target.files[0])
      const uploadFileRes = await this.$faApi.uploadFile(postData)
      const updatedUser = await this.$faApi.updateUserInfo(this.$route.params.userId, {
        avatar: uploadFileRes.filePath
      })
      this.userInfo = updatedUser
    }
  }
}
</script>

<style scoped lang="scss">
  .page {
    position: relative;
    width: 100%;
    min-height: 100vh;
    // padding-bottom: 48px;
    background-color: white;
  }
  .avatar_area {
    position: relative;
    width: 100%;
    height: 256px;
    padding: 48px 0;
    background-color: white;
    .avatar_box {
      position: relative;
      margin: 0 auto;
      width: 160px;
      height: 160px;
      .default {
        background-image: url('../assets/avatar.png')
      }
      .phone {
        position: relative;
        width: 120px;
        height: 48px;
        margin: 0 auto;
        padding-top: 20px;
        text-align: center;
      }
    }
  }

  .table {
    position: relative;
    width: 100%;
    min-height: calc(100vh - 48px);
    background-color: #0000000a;
    .table_section {
      margin-bottom: 12px;
    }
  }
  .link_quit {
    color: red;
    text-align: center;
  }
</style>
  